import { ITile } from "./tile.model";

export class ButtonTile implements ITile {
  public static readonly BackTileKey = "_back-button-key_";
  public static readonly PersonnelTileKey = "_personnel_";
  public static readonly QrTileKey = "_qr-login_";

  public static createBackTile(name: string): ButtonTile {
    return new ButtonTile(ButtonTile.BackTileKey, name, "", "./assets/images/icon_back.svg", "grey-background");
  }

  public static createPersonnelTile(name: string): ButtonTile {
    return new ButtonTile(ButtonTile.PersonnelTileKey, name);
  }

  public static createQrTile(name: string): ButtonTile {
    return new ButtonTile(ButtonTile.QrTileKey, name, "", "./assets/images/qr_code.svg");
  }

  constructor(
    public key: string,
    public name: string,
    public picture: string = "",
    public defaultImage: string = "./assets/images/icon_user.svg",
    public defaultImageClass: string = "blue-background",
    public imageClass: string = ""
  ) { }
}
